import { Input } from "@/components/ui/input";

export const parseDMY = (s) => {
  const m = s.match(/^(\d{2}) (\d{2}) (\d{4})$/);
  if (!m) return null;
  const [d, mo, y] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const dt = new Date(y, mo - 1, d);
  return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d ? dt : null;
};

const mask = (raw) => {
  const digits = raw.replace(/\D/g, "").slice(0, 8);
  return [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)].filter(Boolean).join(" ");
};

export const DateInput = ({ value, onChange, invalid, className = "h-12 text-lg tracking-[0.15em]", ...props }) => (
  <Input value={value} onChange={(e) => onChange(mask(e.target.value))} inputMode="numeric" placeholder="DD MM YYYY"
    className={`bg-white tabular-nums ${className} ${invalid ? "border-red-400 focus-visible:ring-red-300" : ""}`} {...props} />
);
